import React, { useState, useEffect } from "react";
import { Container, TextField, Card, Button, Typography, Grid, CardActions, LinearProgress, InputAdornment, Switch} from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useSelector, useDispatch } from 'react-redux'
import { orgCreate } from 'api/org';
import {useOrgCreateMutation} from 'services/org'
import { v4 as uuidv4 } from 'uuid'
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useOrgEditMutation, useOrgDetailsQuery } from "services/org";

const UsTiresEdit = (props) => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const navi = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const org = useSelector(state=>state.org.create);
    const [disableButton, setDisableButton] = useState(false);
    const [validEmail, setValidEmail] = useState(false);
    const [invalidEmail, setInValidEmail] = useState(false);
    const [emailStatus, setEmailStatus] =  useState('');
    const [ orgEditMutation, { isLoading: isUpdating }] = useOrgEditMutation(); 

    const handleCancel = () =>{
        navi("/orgs/list")
    }

    const handleDelete = () =>{
        navi("/orgs/list")
    }

    const {orgDetails, orgStatus, orgLoading, fetching} = useOrgDetailsQuery({id: id}, 
        {
          selectFromResult: ({ data, status, isLoading, isFetching }) => ({
            orgDetails: data || {},
            orgStatus: status,
            orgLoading: isLoading,
            fetching: isFetching
          })
        }
    );

    useEffect(()=>{
        if(orgDetails.id){
            console.log(orgDetails)
            dispatch(orgCreate(orgDetails));
            setValidEmail(true)
        }
    }, [orgDetails])
        
    const onNameChange = (event) =>{
        dispatch(orgCreate({name: event.target.value}))
    }

    const onCodeChange = (event) =>{
        if(event.target.value !== ' '){
            dispatch(orgCreate({code: event.target.value}))
        } else {

        }
    }

    const onEmailChange = (event) =>{
        dispatch(orgCreate({email: event.target.value}))
    }

    const onStatusChange = (event) =>{
        dispatch(orgCreate({status: event.target.checked}))
    }

    const onEmailBlur = (event) =>{
        
        if(regex.test(event.target.value)){
            console.log('reached', event.target.value)
            setInValidEmail(false);
            setEmailStatus('')
            setValidEmail(true);
        } else {
            setInValidEmail(true);
            setEmailStatus('Invalid E-Mail')
            setValidEmail(false);
        }
    }

    const onPhoneChange = (value) =>{
        var phone = value;
        var phone_number = `+1${value}`;
        if(org.phone.length<11){
            dispatch(orgCreate({phone: phone}));
            dispatch(orgCreate({phone_number: phone_number}));
        }
    }

    const onSave = () =>{
        var record = {
            "doc":{
                ...org
            }
            
        }
        if(validEmail && emailStatus===''){
            setDisableButton(true);
            orgEditMutation(record)
            .unwrap()
            .then(result=>{
                setDisableButton(false);
            })
            .catch(err=>{
                setDisableButton(false);
            })
        }
    }

    return (
        <React.Fragment>
            <CommonListHeader value = {{title: `Edit Organization: ${orgDetails.name}`, description: "You are editing organization details."}} />
            <Container maxWidth={'md'}>
                <Card>
                    {disableButton?<LinearProgress />:''}
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Organization Name</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={onNameChange}
                                value={org.name || ''}  
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Organization Code</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={onCodeChange}
                                value={org.code || ''}  
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">E-Mail</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={onEmailChange}
                                value={org.email || ''}  
                                helperText={emailStatus}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {validEmail?<DoneIcon color="primary" />:invalidEmail?<CloseIcon color="warning" />:''}
                                        </InputAdornment>
                                    )
                                }}
                                onBlur={onEmailBlur}
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Phone</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                type="number"
                                fullWidth
                                onChange={(event)=>onPhoneChange(event.target.value)}
                                value={org.phone || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Status</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Switch checked={org?.status} onChange={(event)=>onStatusChange(event)}/>
                        </Grid>
                    </Grid>


                    
                    
                    <CardActions sx={{padding: "15px"}}>
                        <Button
                            disabled={disableButton}
                            variant="contained"
                            color='primary'
                            type="submit"
                            onClick={() => onSave()}
                        >
                            Submit
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                        <Typography sx={{flexGrow: 1}} />
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleDelete()}
                            color={'warning'}
                        >
                            delete
                        </Button>
                    </CardActions>
                </Card>
            </Container>
        </React.Fragment>
    )

    
}

export default UsTiresEdit;